import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Network/CA_Certificate/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import DangerBox from 'components/Web_User_Interface/1440p_Series/Network/CA_Certificate/DangerBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Netzwerk Menü // CA Zertifikat",
  "path": "/Web_User_Interface/1440p_Serie/Netzwerk/CA_Zertifikat/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die Kamera verwendet CA-Zertifikate, um Remote-Server zu verifizieren. Sie können mehrere CA-Zertifikate von verschiedenen Zertifizierungsorganisationen in einer einzigen .pem-Datei speichern, bevor Sie sie hochladen.",
  "image": "./WebUI_1440p_SearchThumb_Network_IP_Configuration.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Netzwerk Menü // CA Zertifikat' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die Kamera verwendet CA-Zertifikate, um Remote-Server zu verifizieren. Sie können mehrere CA-Zertifikate von verschiedenen Zertifizierungsorganisationen in einer einzigen .pem-Datei speichern, bevor Sie sie hochladen.' image='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Network/CA_Certificate/' locationFR='/fr/Web_User_Interface/1440p_Series/Network/CA_Certificate/' crumbLabel="CA" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "netzwerk-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#netzwerk-men%C3%BC",
        "aria-label": "netzwerk menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/626d8ddf0d6f7b757423e53314aab918/d53ff/1440p_WebUI_Network_CA_Certificate.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.565217391304344%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACNElEQVQoz22SO2/TUBiG+zc6dODi0CZNxVBUQVLXuTlJE9vHx44b20laqaIXEpBIVKUV0AtiaDdEGWlYEEh0qcSCYERCTIz8AX7Ig+L0AhLDo0/fNzx636MzlkwmSSQSJKaTTCrXUZ02i9235DaOyWy8Zn7tGPUvhvvC2iuM3oA56wHpe3PMzMwwPj7OxMQEY0NZPB4nMT2NcuMauv+I5t57vP4bvO0Bbv+E2iWDCK9/wvLBB8rNPoVckVQ6w+StOMnkbcampqZGwkSCWCxGRk3RrEtCT0Q0luzLGbgmdcfAExWkWUQUF3HLq5ilGoVcnoyW/48wk2Wp7uO4Ndyad4njetFNOkNchOPQcAOehy3WQ0GpqDKf1kbC6A3PhZqm0QhDWq0mrVaLRqMRTd/3sW0bKeUIx8URBoc9n15bp1JWmU9pVwmHxBQlEkrPR3oBdT8gDALCMIxwXRdp25HIWCzS6bT59vkj+x2brJYmpy38K7ypKOSzGr1VSXfFxHcFlrCxhUBcpHPreCsPqXqrPNnd5feP75wd7KBnzoUXsmHlm0qMUl5jsC14t2NwPxQYQuJIiS1M7KqOVfOxui/R20d0H2/x88snTo/2WTE0UumF0be5QIkqZ6iIGnpVYtkSx3GQtsBZ7uB0XhA2OzwrFdjKZXm6ucavr2ecHu6w3dTRC7mrhMPqQ6GqqpHAMg1M08AwTYxqBStYx97YYynYpF+u0K9YuLqOZxrIYoHc3Vnm7szyB52igwEoDt6gAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/626d8ddf0d6f7b757423e53314aab918/e4706/1440p_WebUI_Network_CA_Certificate.avif 230w", "/de/static/626d8ddf0d6f7b757423e53314aab918/d1af7/1440p_WebUI_Network_CA_Certificate.avif 460w", "/de/static/626d8ddf0d6f7b757423e53314aab918/7f308/1440p_WebUI_Network_CA_Certificate.avif 920w", "/de/static/626d8ddf0d6f7b757423e53314aab918/ca993/1440p_WebUI_Network_CA_Certificate.avif 1068w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/626d8ddf0d6f7b757423e53314aab918/a0b58/1440p_WebUI_Network_CA_Certificate.webp 230w", "/de/static/626d8ddf0d6f7b757423e53314aab918/bc10c/1440p_WebUI_Network_CA_Certificate.webp 460w", "/de/static/626d8ddf0d6f7b757423e53314aab918/966d8/1440p_WebUI_Network_CA_Certificate.webp 920w", "/de/static/626d8ddf0d6f7b757423e53314aab918/55b8e/1440p_WebUI_Network_CA_Certificate.webp 1068w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/626d8ddf0d6f7b757423e53314aab918/81c8e/1440p_WebUI_Network_CA_Certificate.png 230w", "/de/static/626d8ddf0d6f7b757423e53314aab918/08a84/1440p_WebUI_Network_CA_Certificate.png 460w", "/de/static/626d8ddf0d6f7b757423e53314aab918/c0255/1440p_WebUI_Network_CA_Certificate.png 920w", "/de/static/626d8ddf0d6f7b757423e53314aab918/d53ff/1440p_WebUI_Network_CA_Certificate.png 1068w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/626d8ddf0d6f7b757423e53314aab918/c0255/1440p_WebUI_Network_CA_Certificate.png",
              "alt": "Web User Interface - 1440p Serie - Netzwerk CA-Zertifikate",
              "title": "Web User Interface - 1440p Serie - Netzwerk CA-Zertifikate",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    {
      /* TOC */
    }
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#netzwerk-men%C3%BC"
        }}>{`Netzwerk Menü`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#format"
        }}>{`Format`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#mqtt-ftps-und-https-alarmserver"
        }}>{`MQTT, FTPS und HTTPS Alarmserver`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#nehmen-sie-die-sache-selbst-in-die-hand"
        }}>{`Nehmen Sie die Sache selbst in die Hand`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#mosquitto-broker"
            }}>{`Mosquitto Broker`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#ca-zertifikate"
            }}>{`CA Zertifikate`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#server-zertifikate"
            }}>{`Server Zertifikate`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#client-zertifikate"
            }}>{`Client Zertifikate`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#schlie%C3%9Fen-sie-ihre-instar-ip-kamera-an"
            }}>{`Schließen Sie Ihre INSTAR IP-Kamera an`}</a></li>
        </ul>
      </li>
    </ul>
    {
      /* /TOC */
    }
    <h2 {...{
      "id": "format",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#format",
        "aria-label": "format permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Format`}</h2>
    <p>{`Das CA-Zertifikat wird in der Regel von Ihrer Zertifizierungsstelle bereitgestellt - Sie können z. B. den kostenlosen Dienst von `}<a parentName="p" {...{
        "href": "https://letsencrypt.org/"
      }}>{`Let's Encrypt`}</a>{` nutzen und das CA-Zertifikat von dort zu beziehen - das aktuelle Stammzertifikat ist z. B. das `}<a parentName="p" {...{
        "href": "https://letsencrypt.org/certificates/"
      }}>{`lets-encrypt-r3.pem`}</a>{`. Erzeugen Sie das `}<strong parentName="p">{`X.509-Zertifikat`}</strong>{` und den `}<strong parentName="p">{`privaten RSA-Schlüssel`}</strong>{` mit einem Programm wie `}<a parentName="p" {...{
        "href": "https://certbot.eff.org/instructions"
      }}>{`certbot`}</a>{` und laden Sie sie im Menü `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/SSL_Zertifikat/"
      }}>{`SSL-Zertifikat`}</a>{` hoch. Laden Sie dann das Let's Encrypt-Stammzertifikat hier in den CA Store Ihrer Kamera hoch.`}</p>
    <p>{`Die richtige Formatierung ist wichtig, da die Kamera sonst das digitale Zertifikat nicht akzeptiert. Die Kamera verwendet Zertifikate im PEM-Format. Die Zertifikatsdatei muss daher die Dateierweiterung `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.pem`}</code>{` haben. Der Inhalt der PEM-Datei sieht in etwa wie folgt aus:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`BEGIN CERTIFICATE`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`
MIIFoTCCA4mgAwIBAgIUUuUOKXSIIZ8q9/9Bo+CX529MQKMwDQYJKoZIhvcNAQEL
BQAwYDELMAkGA1UEBhMCQVUxEzARBgNVBAgMClNvbWUtU3RhdGUxITAfBgNVBAoM
GEludGVybmV0IFdpZGdpdHMgUHR5IEx0ZDEZMBcGA1UEAwwQbmFubzE5LmZyaXR6
LmJveDAeFw0yMjA0MDcwNjM0NDZaFw0yNzA0MDYwNjM0NDZaMGAxCzAJBgNVBAYT
AkFVMRMwEQYDVQQIDApTb21lLVN0YXRlMSEwHwYDVQQKDBhJbnRlcm5ldCBXaWRn
aXRzIFB0eSBMdGQxGTAXBgNVBAMMEG5hbm8xOS5mcml0ei5ib3gwggIiMA0GCSqG
SIb3DQEBAQUAA4ICDwAwggIKAoICAQDaEr8NaGrgLuZodIfNZpPEIq8rmB+0D9NH
rB+S0RpaYCSilolR3KMqiP70zzqLdBfK7b3IYgj4etQAx1LZaGqp0xsRDkI8qA56
oiEaAO4Rjc/PME0ra6Ygqvsiz2S1LmeDKcNzPNk+DH7k0pXJK4RLmtCm6oGpREVv
FGjPrTOr8DmEIANzm/cJkZ8B33Z0qHXR9hMShlb63D1V1IaIil9dcygs6lxTiJHZ
wxc2ro3Z9oygV9R8Pw7p25GisXNIhJc6vsWwKbiCEIHvkz+c6Ap9VFqaKf3yp2CT
L7txvGI1yfdM88i2jNqVumotsAM4o5CFKzG3i5qZoioRnxLV757aMEymcQZEX3Oj
LEeojD/Nhry0A5xQ3CSiNSHuxmdMvM6tqVfmoEWrP4MM+aE8BiSu4e9HSk6wbhFr
rMZ7+1lYcP2o0adQqzNH/vpveZ2kxmly556BlZJHorGIALbU4D6P3UB3Iq7s9vl+
42OXnLQmQk6EaNbU57xhdA/UIcvfi2EAOsNW3gdj2KtJSONu18+qSrFFBn6lvnK7
1Smecyb20uYSYxTOnl7mOB7bhO+1xa7Kz06LObiSDta80eCMPilEAgQDemWA3xN3
CS2SWf7XFQlS8cKQgTf93q8RX7IOz3aELDQNPsd0z9TcnaGHvTVQjxCnmlF47qfJ
Yzo+QKHgEwIDAQABo1MwUTAdBgNVHQ4EFgQUKl+1mdOgymWy90NODB6LToHqeOIw
HwYDVR0jBBgwFoAUKl+1mdOgymWy90NODB6LToHqeOIwDwYDVR0TAQH/BAUwAwEB
/zANBgkqhkiG9w0BAQsFAAOCAgEAgk9hblrOir3+afRpjEYwj78Sw07/nnYxkDCv
5dj9mS/uiFYO4N5A75MumOFRCG2PBx7R7HduLrj8i1VRBse6Ftptx8kM+VnSLI8o
t5x2LfLm6qXnuTux13uvmDKuGZnZPE1VYMsGLbQXh1HVxqmKoMl8mCqDrb0na+2z
TIAaMW7Kb8citp2TPoWiD0gmxoz+Hk4UKH00XcRZ/KR81rz1Ifhj2qRPFPO5QKeU
SGIhKRtrEGeahGxTlXZDjq1J3yzAZNIWXwYaM4TmFju8Lhpu4NHNPFHCIN7W3f4S
g5WzKZrmo4co4guZlE9plZOkax3SG5abtWqvrwF2ZjPcmJrAH3GoKF/0/9aek5QR
A6trqEo/tlaPFacj92mkYN0fW7E8ITtqQJylQnpneq0yvcYNE3Ticv62nGlvQUec
rkMFs/BiRxSCI7uOCkFnf3maqQdul3apO5JjVvYNZSP1v0yHVNauYRkMwClYTQ2K
9NfeM45bWSE9DWwz3D4wRA4XfOko2+LGIiZXxpMP41os14Eng/XrU6BGwgHNvckp
VjIAPOka4bYGIu3RJIPF4UL5FppMpJWl7ZIubN27avAguIXZOHmL1u8UDqM8s5H3
3BCPiga2pC+7gllABixNSDhS1facQJ24wDXESyX9mjn8cGKBXF3onRS+/I0IpZ37
bBMdN+A=
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`END CERTIFICATE`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span></code></pre></div>
    <DangerBox mdxType="DangerBox" />
    <h2 {...{
      "id": "mqtt-ftps-und-https-alarmserver",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#mqtt-ftps-und-https-alarmserver",
        "aria-label": "mqtt ftps und https alarmserver permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MQTT, FTPS und HTTPS Alarmserver`}</h2>
    <p>{`Wenn Sie hier ein privates Zertifikat hochladen, wird dieses neben der `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/IP_Configuration/"
      }}>{`HTTPS Verbindung`}</a>{` über Ihre `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/Remote_Access/"
      }}>{`INSTAR DDNS Adresse`}</a>{` auch für den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/MQTT/"
      }}>{`INSTAR MQTT Broker`}</a>{`, den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/Alarm_Server/"
      }}>{`HTTPS Alarmserver`}</a>{` und `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Features/FTP/"
      }}>{`FTPS Dienst`}</a>{`.`}</p>
    <p>{`Wie bereits erwähnt, verwendet Ihre Kamera standardmäßig, wenn Sie kein eigenes Zertifikat hochladen, das CA-Zertifikat, das mit Ihrer persönlichen `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/Fernzugriff/"
      }}>{`INSTAR DDNS-Adresse`}</a>{` geliefert wird. Derzeit werden diese Zertifikate von der Firma `}<a parentName="p" {...{
        "href": "https://godaddy.com"
      }}>{`GoDaddy`}</a>{` ausgestellt. Um eine Verbindung zu Ihrer Kamera unter Verwendung der TLS-Verschlüsselung herstellen zu können, müssen beide Geräte das `}<a parentName="p" {...{
        "href": "https://certs.godaddy.com/repository"
      }}>{`GoDaddy Stammzertifikat`}</a>{` "kennen". Wenn das Betriebssystem Ihres Computers oder Smartphones nicht zu veraltet ist, verfügen sie über eine Kopie, und Ihr Webbrowser wird sich nicht beschweren, wenn Sie auf die Weboberfläche Ihrer Kamera zugreifen.`}</p>
    <p>{`Schwieriger wird es, wenn Sie ein IoT-Gerät über die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Features/FTP/"
      }}>{`FTPS`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/Alarm_Server/"
      }}>{`HTTPS`}</a>{` oder `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/MQTT/"
      }}>{`MQTTS`}</a>{` Schnittstelle verbinden wollen. Diese Geräte verfügen oft nicht über einen CA-Zertifikatspeicher (`}<em parentName="p">{`CA Store`}</em>{`) mit allen gängigen, aktiven Stammzertifikaten. Aus diesem Grund bieten wir die Möglichkeit, diese Dienste in einem `}<strong parentName="p">{`Unsicherer Modus`}</strong>{` (`}<em parentName="p">{`ohne Zertifikats-Verifizierung`}</em>{`) zu nutzen. Die Verschlüsselung ist in diesem Fall nicht weniger sicher, wie der Name andeutet, sondern dieser Modus überspringt nur die Überprüfung, ob die Kamera tatsächlich das Gerät ist, dem die Zertifizierungsstelle das Zertifikat ausgestellt hat.`}</p>
    <p>{`Wenn Sie die Möglichkeit haben, das Root-Zertifikat auf Ihr Gerät - z.B. einen `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/Mosquitto_2.0_with_CA_Certificate/"
      }}>{`Mosquitto MQTT Broker`}</a>{` - hochzuladen, können Sie das GoDaddy Root-Zertifikat auf der `}<a parentName="p" {...{
        "href": "https://certs.godaddy.com/repository"
      }}>{`GoDaddy Website`}</a>{` finden. Das korrekte Zertifikat ist zum Zeitpunkt der Erstellung dieses Artikels das `}<strong parentName="p">{`GoDaddy Certificate Bundles - G2`}</strong>{` `}<a parentName="p" {...{
        "href": "https://certs.godaddy.com/repository/gd_bundle-g2.crt"
      }}>{`gd_bundle-g2.crt`}</a>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`-----BEGIN CERTIFICATE-----
MIIE0DCCA7igAwIBAgIBBzANBgkqhkiG9w0BAQsFADCBgzELMAkGA1UEBhMCVVMx
EDAOBgNVBAgTB0FyaXpvbmExEzARBgNVBAcTClNjb3R0c2RhbGUxGjAYBgNVBAoT
EUdvRGFkZHkuY29tLCBJbmMuMTEwLwYDVQQDEyhHbyBEYWRkeSBSb290IENlcnRp
ZmljYXRlIEF1dGhvcml0eSAtIEcyMB4XDTExMDUwMzA3MDAwMFoXDTMxMDUwMzA3
MDAwMFowgbQxCzAJBgNVBAYTAlVTMRAwDgYDVQQIEwdBcml6b25hMRMwEQYDVQQH
EwpTY290dHNkYWxlMRowGAYDVQQKExFHb0RhZGR5LmNvbSwgSW5jLjEtMCsGA1UE
CxMkaHR0cDovL2NlcnRzLmdvZGFkZHkuY29tL3JlcG9zaXRvcnkvMTMwMQYDVQQD
EypHbyBEYWRkeSBTZWN1cmUgQ2VydGlmaWNhdGUgQXV0aG9yaXR5IC0gRzIwggEi
MA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQC54MsQ1K92vdSTYuswZLiBCGzD
BNliF44v/z5lz4/OYuY8UhzaFkVLVat4a2ODYpDOD2lsmcgaFItMzEUz6ojcnqOv
K/6AYZ15V8TPLvQ/MDxdR/yaFrzDN5ZBUY4RS1T4KL7QjL7wMDge87Am+GZHY23e
cSZHjzhHU9FGHbTj3ADqRay9vHHZqm8A29vNMDp5T19MR/gd71vCxJ1gO7GyQ5HY
pDNO6rPWJ0+tJYqlxvTV0KaudAVkV4i1RFXULSo6Pvi4vekyCgKUZMQWOlDxSq7n
eTOvDCAHf+jfBDnCaQJsY1L6d8EbyHSHyLmTGFBUNUtpTrw700kuH9zB0lL7AgMB
AAGjggEaMIIBFjAPBgNVHRMBAf8EBTADAQH/MA4GA1UdDwEB/wQEAwIBBjAdBgNV
HQ4EFgQUQMK9J47MNIMwojPX+2yz8LQsgM4wHwYDVR0jBBgwFoAUOpqFBxBnKLbv
9r0FQW4gwZTaD94wNAYIKwYBBQUHAQEEKDAmMCQGCCsGAQUFBzABhhhodHRwOi8v
b2NzcC5nb2RhZGR5LmNvbS8wNQYDVR0fBC4wLDAqoCigJoYkaHR0cDovL2NybC5n
b2RhZGR5LmNvbS9nZHJvb3QtZzIuY3JsMEYGA1UdIAQ/MD0wOwYEVR0gADAzMDEG
CCsGAQUFBwIBFiVodHRwczovL2NlcnRzLmdvZGFkZHkuY29tL3JlcG9zaXRvcnkv
MA0GCSqGSIb3DQEBCwUAA4IBAQAIfmyTEMg4uJapkEv/oV9PBO9sPpyIBslQj6Zz
91cxG7685C/b+LrTW+C05+Z5Yg4MotdqY3MxtfWoSKQ7CC2iXZDXtHwlTxFWMMS2
RJ17LJ3lXubvDGGqv+QqG+6EnriDfcFDzkSnE3ANkR/0yBOtg2DZ2HKocyQetawi
DsoXiWJYRBuriSUBAA/NxBti21G00w9RKpv0vHP8ds42pM3Z2Czqrpv1KrKQ0U11
GIo/ikGQI31bS/6kA1ibRrLDYGCD+H1QQc7CoZDDu+8CL9IVVO5EFdkKrqeKM+2x
LXY2JtwE65/3YR8V3Idv7kaWKK2hJn0KCacuBKONvPi8BDAB
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIDxTCCAq2gAwIBAgIBADANBgkqhkiG9w0BAQsFADCBgzELMAkGA1UEBhMCVVMx
EDAOBgNVBAgTB0FyaXpvbmExEzARBgNVBAcTClNjb3R0c2RhbGUxGjAYBgNVBAoT
EUdvRGFkZHkuY29tLCBJbmMuMTEwLwYDVQQDEyhHbyBEYWRkeSBSb290IENlcnRp
ZmljYXRlIEF1dGhvcml0eSAtIEcyMB4XDTA5MDkwMTAwMDAwMFoXDTM3MTIzMTIz
NTk1OVowgYMxCzAJBgNVBAYTAlVTMRAwDgYDVQQIEwdBcml6b25hMRMwEQYDVQQH
EwpTY290dHNkYWxlMRowGAYDVQQKExFHb0RhZGR5LmNvbSwgSW5jLjExMC8GA1UE
AxMoR28gRGFkZHkgUm9vdCBDZXJ0aWZpY2F0ZSBBdXRob3JpdHkgLSBHMjCCASIw
DQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAL9xYgjx+lk09xvJGKP3gElY6SKD
E6bFIEMBO4Tx5oVJnyfq9oQbTqC023CYxzIBsQU+B07u9PpPL1kwIuerGVZr4oAH
/PMWdYA5UXvl+TW2dE6pjYIT5LY/qQOD+qK+ihVqf94Lw7YZFAXK6sOoBJQ7Rnwy
DfMAZiLIjWltNowRGLfTshxgtDj6AozO091GB94KPutdfMh8+7ArU6SSYmlRJQVh
GkSBjCypQ5Yj36w6gZoOKcUcqeldHraenjAKOc7xiID7S13MMuyFYkMlNAJWJwGR
tDtwKj9useiciAF9n9T521NtYJ2/LOdYq7hfRvzOxBsDPAnrSTFcaUaz4EcCAwEA
AaNCMEAwDwYDVR0TAQH/BAUwAwEB/zAOBgNVHQ8BAf8EBAMCAQYwHQYDVR0OBBYE
FDqahQcQZyi27/a9BUFuIMGU2g/eMA0GCSqGSIb3DQEBCwUAA4IBAQCZ21151fmX
WWcDYfF+OwYxdS2hII5PZYe096acvNjpL9DbWu7PdIxztDhC2gV7+AJ1uP2lsdeu
9tfeE8tTEH6KRtGX+rcuKxGrkLAngPnon1rpN5+r5N9ss4UXnT3ZJE95kTXWXwTr
gIOrmgIttRD02JDHBHNA7XIloKmf7J6raBKZV8aPEjoJpL1E/QYVN8Gb5DKj7Tjo
2GTzLH4U/ALqn83/B2gX2yKQOC16jdFU8WnjXzPKej17CuPKf1855eJ1usV2GDPO
LPAvTK33sefOT6jEm0pUBsV/fdUID+Ic/n4XuKxe9tQWskMJDE32p2u0mYRlynqI
4uJEvlz36hz1
-----END CERTIFICATE-----`}</code></pre></div>
    <p>{`Sie müssen dieses Zertifikat `}<strong parentName="p">{`nicht`}</strong>{` auf Ihre Kamera hochladen, da es bereits Teil des internen CA-Speichers ist. Aber wenn Ihr IoT-Dienst sich beschwert, dass er das Zertifikat der Kamera nicht verifizieren kann, können Sie dieses Root-Zertifikat bereitstellen. Z.B. in Ihren `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/Mosquitto_2.0_with_CA_Certificate/"
      }}>{`Mosquitto MQTT Broker`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Hinweis`}</strong>{`: Die Überprüfung des Zertifikats kann nur funktionieren, wenn Sie sich über Ihre `}<a parentName="p" {...{
          "href": "/de/Web_User_Interface/1440p_Series/Network/Remote_Access/"
        }}>{`INSTAR DDNS-Adresse`}</a>{` verbinden. Wenn Sie sich über Ihre lokale IP-Adresse verbinden, müssen Sie den `}<strong parentName="p">{`unsicheren Modus`}</strong>{` aktivieren.`}</p>
    </blockquote>
    <h2 {...{
      "id": "nehmen-sie-die-sache-selbst-in-die-hand",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#nehmen-sie-die-sache-selbst-in-die-hand",
        "aria-label": "nehmen sie die sache selbst in die hand permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Nehmen Sie die Sache selbst in die Hand`}</h2>
    <p>{`In lokalen Netzwerken (LANs) ist es oft ein wenig mühsam, ein CA-Zertifikat zum Laufen zu bringen. Aber Sie können Ihre eigene zertifikat-austellende Autorität werden - das ist eine interessante Lösung, wenn Sie einen Domänendienst eingerichtet haben, der allen Ihren lokalen Netzwerkgeräten Domänennamen zuweist (z. B. mit einem `}<strong parentName="p">{`AVM Firtzbox Internet Router`}</strong>{` haben Sie die lokale Domäne `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fritz.box`}</code>{`, die Sie verwenden können).`}</p>
    <p><strong parentName="p">{`Ok, jetzt wird es ein bisschen kompliziert`}</strong>{`. Wenn Sie sich mit Ihrem Computerterminal nicht auskennen, ist es besser, sich an das INSTAR DDNS-Zertifikat zu halten. Dort haben wir bereits alles für Sie vorbereitet und es ist absolut sicher dieses für die Verschlüsselung zu nutzen. Alles unten folgende ist absolut `}<strong parentName="p">{`OPTIONAL`}</strong>{`.`}</p>
    <p>{`Aber schauen wir es uns einmal im Detail an...`}</p>
    <h3 {...{
      "id": "mosquitto-broker",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#mosquitto-broker",
        "aria-label": "mosquitto broker permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Mosquitto Broker`}</h3>
    <p>{`Im Beispiel möchte ich mein eigenes Zertifikat erstellen, um es mit einem externen `}<strong parentName="p">{`Mosquitto Broker`}</strong>{` zu verwenden. Dieser läuft auf einem `}<strong parentName="p">{`Debian Bullseye`}</strong>{` Server - zum Beispiel einem Raspberry Pi. Der Broker wird gemäß der Anleitung `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/Mosquitto_2.0_with_CA_Certificate/"
      }}>{`Mosquitto 2.0 mit CA-Zertifikat`}</a>{` eingerichtet, wobei die in den folgenden Schritten erzeugten Zertifikate verwendet werden sollen.`}</p>
    <p><em parentName="p">{`Erstellen eines selbstsignierten Zertifikats`}</em></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Anforderungen des Clienten`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Ein CA-Zertifikat der CA (Certificate Authority), die das Server-Zertifikat auf dem Mosquitto Broker signiert hat.`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Anforderungen des Brokers`}</p>
        <ul parentName="li">
          <li parentName="ul">{`CA-Zertifikat der CA, die das Server-Zertifikat auf dem Mosquitto Broker signiert hat.`}</li>
          <li parentName="ul">{`CA-zertifiziertes Server-Zertifikat.`}</li>
          <li parentName="ul">{`Server Privater Schlüssel für die Entschlüsselung.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Stellen Sie sicher, dass Sie eine neue Version von `}<strong parentName="p">{`OpenSSL`}</strong>{` installiert haben:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl version
OpenSSL `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1.1`}</span>{`.1l  `}<span parentName="code" {...{
            "className": "token number"
          }}>{`24`}</span>{` Aug `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2021`}</span></code></pre></div>
    <p>{`Mosquitto legt bereits ein Verzeichnis für selbstsignierte Zertifikate an - falls es nicht existiert, erstellen Sie es mit:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`mkdir`}</span>{` -p /etc/mosquitto/certs
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`chown`}</span>{` mosquitto:mosquitto /etc/mosquitto/certs`}</code></pre></div>
    <h3 {...{
      "id": "ca-zertifikate",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#ca-zertifikate",
        "aria-label": "ca zertifikate permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`CA Zertifikate`}</h3>
    <p>{`Beginnen wir mit der Erzeugung eines Schlüssels:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` /etc/mosquitto/certs
openssl genrsa -out ca.key `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4096`}</span></code></pre></div>
    <p>{`Jetzt können wir diesen Schlüssel weiter verwenden, um unseren CA-Schlüssel und unser Zertifikat zu signieren.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Wichtig`}</strong>{`: Die `}<strong parentName="p">{`FQDN`}</strong>{` darf nicht mit dem `}<strong parentName="p">{`FQDN`}</strong>{` des Servers übereinstimmen, sonst kann es zu SSL-Fehlern kommen. In einem lokalen Netzwerk mit einem AVM Fritzbox-Router erhält jedes Gerät sowohl einen Hostnamen - zum Beispiel identifiziert sich mein Mosquitto-Server als `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`debian11`}</code>{` (dies können Sie in der Fritzbox Oberfläche festlegen) - als auch einen Domainnamen `}<strong parentName="p">{`Hostname + .fritz.box`}</strong>{`. So kann ich zum Beispiel auf den Mosquitto-Webserver zugreifen über `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`http://debian11.fritz.box:8080/`}</code>{`.`}</p>
    </blockquote>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl req -new -x509 -days `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1825`}</span>{` -key ca.key -out ca.crt

You are about to be asked to enter information that will be incorporated
into your certificate request.
What you are about to enter is what is called a Distinguished Name or a DN.
There are quite a few fields but you can leave some blank
For some fields there will be a default value,
If you enter `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'.'`}</span>{`, the field will be left blank.
-----
Country Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{` letter code`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`AU`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
State or Province Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`full name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`Some-State`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Locality Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, city`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Organization Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, company`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`Internet Widgits Pty Ltd`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:INSTAR
Organizational Unit Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, section`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Common Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`e.g. server FQDN or YOUR name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:debian11.fritz.box
Email Address `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:`}</code></pre></div>
    <p>{`Stellen Sie sicher, dass Ihr Mosquitto Broker die generierte Datei lesen darf:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`chown`}</span>{` mosquitto:mosquitto ca.`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`crt,key`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Die hier erzeugte Datei `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`*.cert`}</code>{` ist diejenige, die wir später in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`*.pem`}</code>{` umbenennen und in das Menü `}<strong parentName="p">{`Custom CA Store`}</strong>{` unserer Kamera hochladen werden.`}</p>
    <h3 {...{
      "id": "server-zertifikate",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#server-zertifikate",
        "aria-label": "server zertifikate permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Server Zertifikate`}</h3>
    <p>{`Nun müssen wir unsere Serverzertifikate generieren - die Schritte sind praktisch identisch. Wir beginnen mit der Erzeugung eines Schlüssels:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl genrsa -out server.key `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4096`}</span></code></pre></div>
    <p>{`Jetzt können wir diesen privaten Schlüssel verwenden, um unser Zertifikat zu signieren:`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Wichtig`}</strong>{`: Hier muss die `}<strong parentName="p">{`FQDN`}</strong>{` der Hostname sein, sonst kann es zu SSL-Fehlern kommen. Wie oben erwähnt, ist mein Server unter dem Hostnamen `}<strong parentName="p">{`debian11`}</strong>{` erreichbar - ich kann dies testen, indem ich den mosquitto Webserver besuche `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`http://debian11:8080/`}</code>{`.`}</p>
    </blockquote>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl req -new -out server.csr -key server.key

You are about to be asked to enter information that will be incorporated
into your certificate request.
What you are about to enter is what is called a Distinguished Name or a DN.
There are quite a few fields but you can leave some blank
For some fields there will be a default value,
If you enter `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'.'`}</span>{`, the field will be left blank.
-----
Country Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{` letter code`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`AU`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
State or Province Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`full name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`Some-State`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Locality Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, city`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Organization Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, company`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`Internet Widgits Pty Ltd`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:INSTAR
Organizational Unit Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, section`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Common Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`e.g. server FQDN or YOUR name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:debian11
Email Address `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:

Please enter the following `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'extra'`}</span>{` attributes
to be sent with your certificate request
A challenge password `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
An optional company name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:`}</code></pre></div>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl x509 -req -in server.csr -CA ca.crt -CAkey ca.key -CAcreateserial -out server.crt -days `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1825`}</span>{`

Signature ok
`}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`subject`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`C `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` AU, ST `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` Some-State, O `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` INSTAR, CN `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` debian11
Getting CA Private Key`}</code></pre></div>
    <p>{`Auch hier müssen wir sicherstellen, dass Mosquitto unsere Dateien lesen darf:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`chown`}</span>{` mosquitto:mosquitto server.`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`csr,key,crt`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Das certs-Verzeichnis sollte nun die folgenden Dateien enthalten:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`-rw-r--r-- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` mosquitto mosquitto `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1956`}</span>{` Feb `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span>{`:31 ca.crt
-rw------- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` mosquitto mosquitto `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3243`}</span>{` Feb `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span>{`:30 ca.key
-rw-r--r-- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` root      root        `}<span parentName="code" {...{
            "className": "token number"
          }}>{`41`}</span>{` Feb `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span>{`:37 ca.srl
-rw-r--r-- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` mosquitto mosquitto `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1834`}</span>{` Feb `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span>{`:37 server.crt
-rw-r--r-- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` mosquitto mosquitto `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1659`}</span>{` Feb `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span>{`:37 server.csr
-rw------- `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` mosquitto mosquitto `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3243`}</span>{` Feb `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span>{`:34 server.key`}</code></pre></div>
    <h3 {...{
      "id": "client-zertifikate",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#client-zertifikate",
        "aria-label": "client zertifikate permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Client Zertifikate`}</h3>
    <p>{`Für mehr Sicherheit können Sie Client-Zertifikate hinzufügen, die vom Server signiert werden müssen. Erzeugen Sie Client-Zertifikate für die MQTT-Clients. Wichtig: `}<strong parentName="p">{`Der Servername darf nicht als FQDN`}</strong>{` verwendet werden:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl genrsa -out client.key `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4096`}</span>{`
openssl req -out client.csr -key client.key -new`}</code></pre></div>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`You are about to be asked to enter information that will be incorporated
into your certificate request.
What you are about to enter is what is called a Distinguished Name or a DN.
There are quite a few fields but you can leave some blank
For some fields there will be a default value,
If you enter `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'.'`}</span>{`, the field will be left blank.
-----
Country Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{` letter code`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`AU`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
State or Province Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`full name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`Some-State`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Locality Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, city`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Organization Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, company`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`Internet Widgits Pty Ltd`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:INSTAR
Organizational Unit Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eg, section`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
Common Name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`e.g. server FQDN or YOUR name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:mqtt.client
Email Address `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:

Please enter the following `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'extra'`}</span>{` attributes
to be sent with your certificate request
A challenge password `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:
An optional company name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`:`}</code></pre></div>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`openssl x509 -req -in client.csr -CA ca.crt --CAkey ca.key --CAcreateserial -out client.crt -days `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1825`}</span>{`

Signature ok
`}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`subject`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`C `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` AU, ST `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` Some-State, O `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` INSTAR, CN `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` mqtt.client
Getting CA Private Key`}</code></pre></div>
    <p>{`Und noch einmal - setzen wir die richtigen Berechtigungen:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`chown`}</span>{` mosquitto:mosquitto client.`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`csr,crt,key`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h3 {...{
      "id": "schließen-sie-ihre-instar-ip-kamera-an",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#schlie%C3%9Fen-sie-ihre-instar-ip-kamera-an",
        "aria-label": "schließen sie ihre instar ip kamera an permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Schließen Sie Ihre INSTAR IP-Kamera an`}</h3>
    <p>{`Um Ihre INSTAR-Kamera anzuschließen, müssen Sie zunächst 2 Dinge tun:`}</p>
    <ol>
      <li parentName="ol">{`Kombinieren Sie `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`client.key`}</code>{` und `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`client.crt`}</code>{` in eine einzige Datei namens `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`client.pem`}</code>{`:`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`-----BEGIN RSA PRIVATE KEY-----
MIIJKAIBAAKCAgEAorc0ouM2Uh0pBlZ5IbCSonwOACUCPQ+FqWjhRl5FbAAke2iK

`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`.

l6hxaLG33DoTvYoEbjBEmLtsBAz4sdnTGi2z6HOYfMsqGjMehPJmr2XH/kA`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`
-----END RSA PRIVATE KEY-----
-----BEGIN CERTIFICATE-----
MIIFIDCCAwgCFHLf6A9ycbmW6ExF+DBGE3T3qhFAMA0GCSqGSIb3DQEBCwUAMFAx

`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`.

`}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`CVSpxYNxMG6gIpeIFrTogygOfdc`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`
-----END CERTIFICATE-----`}</code></pre></div>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Nehmen Sie die Datei `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ca.crt`}</code>{` und speichern Sie sie als `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`ca.pem`}</code>{`.`}</li>
    </ol>
    <p>{`Öffnen Sie nun das `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/SSL_Zertifikat/"
      }}>{`SSL-Zertifikat-Menü`}</a>{` Ihrer Kamera, fügen Sie die `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`client.pem`}</code>{` als Ihr benutzerdefiniertes Zertifikat hinzu und aktivieren Sie es:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/ecf19/1440p_WebUI_Network_CA_Certificate_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "89.99999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAIAAADUsmlHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC20lEQVQ4y12SW08aQRiG+QtNmibURIKmyi4LIrumFw0VFU8IOOedmd1FPCAo0FpFq1LBWrWxV70ztSZNemnbC/9hMysen3wXc/Ps+858G4jH40Yspg0OmKmZfPPX5LufmcaP0bXzt1V/1vzxz5n6+fzOb7Dw4cXzZ8Hgy2AwGDAMw4jFIgOvXo/NlU7+ic6VPPxjt6/Ywe201dD2lXv0d/H0mld2R1NvxsbH0+l0QNf1aDSqaVpyOMFQwWFIMuTYSFAoKJQMSnUAauBsYSZdW6+enX07PTnpdDoBTdOi0aiu66Zp2TaXUgohpXQIZQhjjAnCGGGEMCGNr7DcWlleaTa3tza3GvVGV9Y0zTRNQghjjFJKCMFPIbTSQqWNSqW6v9/ab30qL5TuZcuyCCGu63pF7wYIIboFQggLWZDP1hv1duewudta9JaUrOu6Sk4mCSGe51FKVVO/LcaqAiFECCEdF0K0Xqt9Pjr62Go7zmJXjkQiSV8WQmCMVQ6AlDAhBOdcKDijFEBYq9UODo9WGtuzc0yt6mFtztWbSSFlUSLpZ/sghMrlMmNstbq2Wt8WC9WZWRiI+tw9mOu6fprgLoccIti9MEJoeXmZc55KpWKx+FAioevRrhyJRMykkh3HwRgDACDomgipdJtzZqtFJJPJnp6ekM+9fHPnpaUl27ZVFO6aNmOe5xWLRdfzmG1blhUKhfr7+8Ph8EPZpJSUFjwp+MMlqeVTyoWUjsOYknt7e/v6+rqyYRjqwUwzD0kW2DnI0OP/Q30C5gnMUQQeyYaPrmuxhHW6Xrju5C6bcxTfRWOEqZLXj/nOBat9sUzzUfJN7cSwWXHBXhlslObxXWlQgPlZVMjm3NW5xffzxYplPZA1n8HBQcs05xHNApIHxIcSBEh5R+xdks3vJzlwMT19nMubIyNPZZWcSEz5TN6RmZjMkSm6mkElZ3yynB53JjLxoaFQKKTUcPg/9DBC0gayzq0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/e4706/1440p_WebUI_Network_CA_Certificate_01.avif 230w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/d1af7/1440p_WebUI_Network_CA_Certificate_01.avif 460w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/7f308/1440p_WebUI_Network_CA_Certificate_01.avif 920w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/4ce31/1440p_WebUI_Network_CA_Certificate_01.avif 948w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/a0b58/1440p_WebUI_Network_CA_Certificate_01.webp 230w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/bc10c/1440p_WebUI_Network_CA_Certificate_01.webp 460w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/966d8/1440p_WebUI_Network_CA_Certificate_01.webp 920w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/af3d9/1440p_WebUI_Network_CA_Certificate_01.webp 948w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/81c8e/1440p_WebUI_Network_CA_Certificate_01.png 230w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/08a84/1440p_WebUI_Network_CA_Certificate_01.png 460w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/c0255/1440p_WebUI_Network_CA_Certificate_01.png 920w", "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/ecf19/1440p_WebUI_Network_CA_Certificate_01.png 948w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/ccdcf5b9c0c0e63e182bfdb2bdaf3dac/c0255/1440p_WebUI_Network_CA_Certificate_01.png",
              "alt": "Schließen Sie Ihre INSTAR IP-Kamera an",
              "title": "Schließen Sie Ihre INSTAR IP-Kamera an",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Und zweitens fügen Sie die `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`ca.pem`}</code>{` hier im Menü `}<strong parentName="p">{`CA Custom Store`}</strong>{` ein:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/0fa840c387c47c11db75ff4620301efe/47aef/1440p_WebUI_Network_CA_Certificate_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.565217391304344%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAB1ElEQVQoz2WRS2/TQBRG/SvSsktaYhPGWCRC5dE8PZM4fkw8nhmPZ5y4DQmoFQrQJpUIUlshFqxYpKvuEBKwh3+I4rSqEJ+O7u7ovjTLsgAA5iPrQXkHjS/Ci9/O4md3/ss+/Qd4+oN/+tMcXTbr+9VarVAolEolzTRNsLZN/f5uX81Gy+tkvpKLKzG/EvNVXtck81W2vA7GZ0+f7b3Yb1SrT7a272kP8wAAdN1A7cZQEBFhyf6DBjHxfBc9b9Rhr6+GE+vxnrYxAQCGYSCEhJCUccbjNTGn7A6RyAAP2jaqtzucjzzM72Rd1yGEqVJpmiqlpJL0gFJKOeeU0izLZrOZ7wew2292IGOjMJRapVLZTJ7LiIqUcBlRxhijeRVCJImQgknBMMbdntuG3Vgc0mh4IwMAymXdc9DlG/FxilMRkYjSXM+7S3b4jr88wYSjnttBfSknnB9o4Da7ZX3Qt78tw+8f/KkiA5KLZEADh3CBT76Gi5VLEth1Gh17lB0pOb19Vb6zDZEfJQ5m0fpojFHCx2/Z7Mtw/P68Bz/7XgDtHcOo1aoMsziZ3Lxqs3Or1QoHGAd+4OfxXD95Fbw+p/L4DDlLFzvN5tZ2oVgsVsq6aVX/AmMMsF3q2/qDAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/0fa840c387c47c11db75ff4620301efe/e4706/1440p_WebUI_Network_CA_Certificate_02.avif 230w", "/de/static/0fa840c387c47c11db75ff4620301efe/d1af7/1440p_WebUI_Network_CA_Certificate_02.avif 460w", "/de/static/0fa840c387c47c11db75ff4620301efe/7f308/1440p_WebUI_Network_CA_Certificate_02.avif 920w", "/de/static/0fa840c387c47c11db75ff4620301efe/29832/1440p_WebUI_Network_CA_Certificate_02.avif 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/0fa840c387c47c11db75ff4620301efe/a0b58/1440p_WebUI_Network_CA_Certificate_02.webp 230w", "/de/static/0fa840c387c47c11db75ff4620301efe/bc10c/1440p_WebUI_Network_CA_Certificate_02.webp 460w", "/de/static/0fa840c387c47c11db75ff4620301efe/966d8/1440p_WebUI_Network_CA_Certificate_02.webp 920w", "/de/static/0fa840c387c47c11db75ff4620301efe/0ca5b/1440p_WebUI_Network_CA_Certificate_02.webp 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/0fa840c387c47c11db75ff4620301efe/81c8e/1440p_WebUI_Network_CA_Certificate_02.png 230w", "/de/static/0fa840c387c47c11db75ff4620301efe/08a84/1440p_WebUI_Network_CA_Certificate_02.png 460w", "/de/static/0fa840c387c47c11db75ff4620301efe/c0255/1440p_WebUI_Network_CA_Certificate_02.png 920w", "/de/static/0fa840c387c47c11db75ff4620301efe/47aef/1440p_WebUI_Network_CA_Certificate_02.png 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/0fa840c387c47c11db75ff4620301efe/c0255/1440p_WebUI_Network_CA_Certificate_02.png",
              "alt": "Schließen Sie Ihre INSTAR IP-Kamera an",
              "title": "Schließen Sie Ihre INSTAR IP-Kamera an",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Konfigurieren Sie den Client so, dass er den Hostnamen Ihres MQTT-Brokers anstelle der lokalen IP verwendet, um die Option `}<strong parentName="p">{`Verify TLS Certificate`}</strong>{` aktivieren zu können:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/170ebde9ca921339ecf35341c088aaab/78597/1440p_WebUI_Network_CA_Certificate_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "80.8695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAACXBIWXMAAAsTAAALEwEAmpwYAAACeUlEQVQoz22S3W/SUBiH+SPM1ISAw0VaSoGR2TLRuKwFWkoL56vntO5DVzbZ2MaHG1MZw+1KvDDe6xJNNN4Z/0TTls059+S9OL14+nvPe95INpsVxQyfnJNKpHH8Sxv8VPrfld4NVT38Yb/7XXvWvjtza+b2nWg0Gkn7iNyDuUUVuMNvZPAZH30hR+f/l/PmfHX01fE6Va2s6bqiKJFUKiUIAs/z0kLeBiZDFrQ0UKuAWgWaFWBWwjMwyqBuWsjp7e9OPkzeTyaDwSAiCEI6neZ5XpYLGBMIEcKY2DaxKUTY/yIEY4KwfwYQbW697Pf6/X7f87ypzHGcJEkYY0qp53nNzc1ms/l8fZ0EUEptQhCxAXHb7d3hcDgcnaw5bnjnqcwYcxzHdV1GGfR7QKZp6rpeCdCqNR24nc7+8Wj86mjoEMdPFgQhmUxKkkQZY4zato0QCuVyuVwsFmVZlgsF6eHC08ePut3u2enp69EYYTdoWxAuk0MIITCwDcNQVVUJWFZLZQN0O523o9MXOwelUt1vW5jKMg2inUsZhn8IgADRFbC219re2Wj16MqWohr+U11MW6aUOg6zbfu6GVwDEYZXW4uLhVRKEMVMMslFeJ4XRZHjOFmWGPOj4V8VGlWjpJbCrpfVUrVu57KZaDR6L8CXw2R/YJRRSq/Gapq2tLT0JKBYLJZVJZ/Px+PxROL+7OzsVA4HhhACAMCrIH9n/EVByC9McrlcLB5LJBK+HK7npQyvUTeBpYO6YUCgQ2hhNJ/LxWIX8tV3vi6DBlxr49YYeod9E5xUrT2rkZnPxS9lPuAmGcFGHW0c0N4ntH02rjU+GtbA/Ef+A837Gtr5K6SuAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/170ebde9ca921339ecf35341c088aaab/e4706/1440p_WebUI_Network_CA_Certificate_03.avif 230w", "/de/static/170ebde9ca921339ecf35341c088aaab/d1af7/1440p_WebUI_Network_CA_Certificate_03.avif 460w", "/de/static/170ebde9ca921339ecf35341c088aaab/7f308/1440p_WebUI_Network_CA_Certificate_03.avif 920w", "/de/static/170ebde9ca921339ecf35341c088aaab/3d505/1440p_WebUI_Network_CA_Certificate_03.avif 947w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/170ebde9ca921339ecf35341c088aaab/a0b58/1440p_WebUI_Network_CA_Certificate_03.webp 230w", "/de/static/170ebde9ca921339ecf35341c088aaab/bc10c/1440p_WebUI_Network_CA_Certificate_03.webp 460w", "/de/static/170ebde9ca921339ecf35341c088aaab/966d8/1440p_WebUI_Network_CA_Certificate_03.webp 920w", "/de/static/170ebde9ca921339ecf35341c088aaab/19b8a/1440p_WebUI_Network_CA_Certificate_03.webp 947w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/170ebde9ca921339ecf35341c088aaab/81c8e/1440p_WebUI_Network_CA_Certificate_03.png 230w", "/de/static/170ebde9ca921339ecf35341c088aaab/08a84/1440p_WebUI_Network_CA_Certificate_03.png 460w", "/de/static/170ebde9ca921339ecf35341c088aaab/c0255/1440p_WebUI_Network_CA_Certificate_03.png 920w", "/de/static/170ebde9ca921339ecf35341c088aaab/78597/1440p_WebUI_Network_CA_Certificate_03.png 947w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/170ebde9ca921339ecf35341c088aaab/c0255/1440p_WebUI_Network_CA_Certificate_03.png",
              "alt": "Schließen Sie Ihre INSTAR IP-Kamera an",
              "title": "Schließen Sie Ihre INSTAR IP-Kamera an",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Und stellen Sie sicher, dass Ihr `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/Mosquitto_2.0_with_CA_Certificate/"
      }}>{`Mosquitto-Broker so eingerichtet ist`}</a>{`, dass er die gleichen Zertifikate verwendet.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      